// Packages
import { Link } from 'react-router-dom'
// Hooks
import { useTranslation } from 'react-i18next'
import useDetectOutsideClick from '../../hooks/useDetectOutsideClick'
// Utils
import persianDate from '../../utils/persianDate'
import persianDay from '../../utils/persianDay'
// Components
import HamburgerIcon from '../../components/icons/HamburgerIcon'
import Logo from '../../components/logo/Logo'
import Avatar from './components/Avatar'
import HamburgerMenu from './components/HamburgerMenu'
import UserInfo from './components/UserInfo'
import UserMenu from './components/UserMenu'

const Header = () => {
  const { t } = useTranslation()

  const {
    triggerRef: avatarTriggerRef,
    nodeRef: avatarNodeRef,
    show: avatarShow,
    setShow: avatarSetShow,
  } = useDetectOutsideClick(false)

  const {
    triggerRef: hamburgerMenuTriggerRef,
    nodeRef: hamburgerMenuNodeRef,
    show: hamburgerMenuShow,
    setShow: hamburgerMenuSetShow,
  } = useDetectOutsideClick(false)

  const handleUserMenuDetectClose = () => {
    avatarSetShow(false)
  }
  const handleHamburgerMenuDetectClose = () => {
    hamburgerMenuSetShow(false)
  }

  return (
    <header className='flex items-center justify-between fixed z-20 top-0  h-16 w-full shadow-sm px-4 bg-neutral-50'>
      {/* Right section */}
      <div className='flex items-center'>
        {/* Hamberger menu for show sidebar menu when device is mobile or tablet */}
        <div className='relative block lg:hidden ml-4 lg:ml-0 items-center'>
          <div ref={hamburgerMenuTriggerRef}>
            <HamburgerIcon />
          </div>
          <HamburgerMenu
            ref={hamburgerMenuNodeRef}
            show={hamburgerMenuShow}
            onClickHamburgerIcon={handleHamburgerMenuDetectClose}
          />
        </div>
        {/* Company name and logo */}
        <Link to='/'>
          <div className='flex items-center'>
            <Logo classes='w-auto h-10' />
            <div className='hidden h-10 lg:block mr-3 text-sm font-medium lg:text-lg text-primary mt-5'>
              {t('companyName')}
            </div>
          </div>
        </Link>
      </div>
      {/* Left section */}
      <div className='flex items-center justify-center'>
        <div className='hidden lg:block ml-3 text-xs text-gray-400'>
          <span className='ml-1'>{t('today')} : </span>
          <span className='ml-4'>{persianDay(new Date())} </span>
          <span>{persianDate(new Date())}</span>
        </div>

        <span className='hidden lg:block text-gray-300 ml-3'>|</span>
        <UserInfo classes='hidden lg:flex' />
        <div className='relative flex items-center justify-center rounded-full'>
          <Avatar ref={avatarTriggerRef} classes='cursor-pointer hover:text-blue-400' />
          <UserMenu ref={avatarNodeRef} show={avatarShow} handleClick={handleUserMenuDetectClose} />
        </div>
      </div>
    </header>
  )
}

export default Header
